import { createSelector } from 'reselect';
import { compose, first, get, isEmpty, negate, orderBy } from 'lodash/fp';
import { array, option } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { getEnterpriseBookableServices } from '../ducks/services';
import { getSelectedServiceId } from '../ducks/serviceSelect';

const getEnterpriseDefaultService = createSelector(
    getEnterpriseBookableServices,
    compose(first, orderBy(['ordering', 'createdUtc'], ['asc', 'asc']))
);

export const getEnterpriseDefaultServiceId = createSelector(getEnterpriseDefaultService, get('id'));

const getUserPreferredService = createSelector(
    getEnterpriseDefaultService,
    getSelectedServiceId,
    getEnterpriseBookableServices,
    (defaultService, selectedServiceId, services) => {
        const currentService = pipe(
            services,
            // @ts-expect-error $TSFixMeError: Argument of type '<B extends { id: any; }>(bs: B[]) => Option<B>' is not assignable to parameter of type '(a: LodashFilt...
            array.findFirst(({ id }) => id === selectedServiceId),
            option.toNullable
        );

        return currentService || defaultService;
    }
);

export const getUserPreferredServiceId = createSelector(getUserPreferredService, get('id'));

export const hasEnterpriseServiceId = createSelector(getEnterpriseDefaultServiceId, negate(isEmpty));
